import { FC } from 'react';
import { AuthUserProvider } from '../../../context/authUser.context';
import LoginView from './login.view';

const LoginViewRoot: FC = () => {
  return (
    <AuthUserProvider>
      <LoginView />
    </AuthUserProvider>
  );
};

export default LoginViewRoot;
